import * as React from 'react';
import { Button, styled, Typography } from '@mui/material';

import Column from 'src/frontend-common/components/Column';
import Success from 'src/frontend-common/components/Icons/Success';
import { Link } from 'react-router-dom';
import Logo from 'src/frontend-common/components/Logo';

const Container = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(5),
  width: '100%',
  alignSelf: 'center',
  [theme.breakpoints.up('xl')]: {
    maxWidth: '1002.5px',
    padding: theme.spacing(15),
  },
}));

const Spacer = styled(Column)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 32,
  lineHeight: 1.2,
  color: theme.palette.primary.main,
  marginBottom: 20,
  textAlign: 'center',
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  lineHeight: 1.1,
  color: theme.palette.text.primary,
  textAlign: 'center',
}));

const CustomButton = styled(Button)(({ theme }) => ({
  height: 56,
  width: '100%',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(3),
  },
}));

const CustomLink = styled(Link)(({}) => ({
  color: '#FFFFFF',
  width: '100%',
  textDecoration: 'none',
}));

const ConfirmSuccessPage: React.FC = () => {
  return (
    <Container>
      <div style={{ marginBottom: 95 }}>
        <Logo />
      </div>
      <div style={{ marginBottom: 24 }}>
        <Success />
      </div>

      <Spacer centered>
        <Title style={{ fontSize: 40, fontWeight: 600, color: 'black' }}>Success</Title>
        <Subtitle>
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: '#616161',
              marginBottom: 24,
            }}
          >
            Your account in now active. Please go back to login page and enter your credential.
          </Typography>
        </Subtitle>
      </Spacer>

      <Column centered>
        <CustomButton
          variant="contained"
          style={{ backgroundColor: 'black' }}
          disableElevation={true}
          // onClick={resendCallback.callback}
        >
          <CustomLink to="/login"> Back to login</CustomLink>
        </CustomButton>
      </Column>
    </Container>
  );
};

export default ConfirmSuccessPage;
